import React from "react";

import { Context, fetchClasses } from "../../../teacherStore";
import ClassDataList from "../../../templates/teacher/ClassDataList";

export default () => {
  const { state, dispatch } = React.useContext(Context);

  React.useEffect(() => {
    dispatch(fetchClasses());
  }, [dispatch]);

  return <ClassDataList classes={state.classes} />;
};
